// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3r2JG","col":"styles_col__3t8X8"};